import React from 'react';

export default function CareerExplorerPage() {
  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 50 }}>
      <iframe
        src="/careerexplorer/index.html"
        style={{ width: '100%', height: '100%', border: 'none', display: 'block' }}
        title="Career Explorer"
      />
    </div>
  );
}
